export default {
  title: 'Modificadores',
  master_title: 'Modo marca - Modificadores',
  products_creation_disabled:
    'Devido à integração ativa com {{integration}}, a criação de novos produtos não é permitida. Se precisar de alterar o menu, faça as alterações em {{integration}} e sincronize o menu.',
  labels: {
    select_all: 'Selecionar tudo',
  },
  buttons: {
    add_modifier: 'Adicionar modificador',
    delete_selected: 'Eliminar selecionados',
    refresh: 'Atualizar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
